<template>
     <div class="mt-3" ref="preguntasDiv">
         <v-row align="center" justify="center" v-if="this.$route.params.show_logo">
             <LogoDI></LogoDI>
        </v-row>

        <BackHeader title="Preguntas Frecuentes" :onBack="volver"></BackHeader>

        <v-card class="ma-5">
            <v-col align="justify">
                <div class="ma-5 contenido-html" style="max-width: 70vw;" v-html="bienvenida"></div>
                <ContactosRepresentantes></ContactosRepresentantes>
            </v-col>
        </v-card>
        <div class="ma-5">
            <div>
                <v-expansion-panels multiple >
                    <v-expansion-panel v-for="(values) in data_preguntas">
                        <v-expansion-panel-header> <h2>{{values.nombre}}</h2> </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-expansion-panels accordion  multiple>
                                <v-expansion-panel v-for="(pregunta) in values.preguntas" @change="toggleActive(pregunta.numero)">
                                    <v-expansion-panel-header>  <h3 :class="{ active: isActive[pregunta.numero] }">{{pregunta.numero}}. {{pregunta.pregunta}}</h3></v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div class="my-3 mx-16 contenido-html" v-html=pregunta.respuesta></div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
            </v-expansion-panels>
            </div>
        </div>

    </div>

</template>

<script>
import LogoDI from "@/components/icons/logoDI";
import axios from 'axios';
import BackHeader from "@/components/content/BackHeader";
import ContactosRepresentantes from "@/components/content/ContactosRepresentantes";

export default {
    components: {LogoDI,BackHeader,ContactosRepresentantes},

    data() {
        return {
            data_preguntas:[],
            bienvenida: "",
            numero:0,
            isActive: [],
        };
    },
    created(){
        // La bienvenida es la pregunta "index": no cuelga de ninguna seccion,
        // asi que no viene en /seccionpregunta y se pide aparte.
        axios({
            url: `${process.env.VUE_APP_API_URL}/pregunta/bienvenida/`,
            method: "GET",
        }).then((response) => {
            this.bienvenida = response.data.respuesta;
        });
        axios({
            url: `${process.env.VUE_APP_API_URL}/seccionpregunta`,
            method: "GET",
        }).then((response) => {
            // this.data_preguntas = response.data;
            let numero = 1;
            this.data_preguntas = response.data.map(seccion => {
                seccion.preguntas = seccion.preguntas.map(pregunta => {
                pregunta.numero = numero++;
                return pregunta;
            });
            return seccion;
            });
        });
    },

    methods:{
        volver() {
            if (this.$route.params.back_info){
                this.$router.push(this.$route.params.back_info);
            } else
            this.$router.push("/");
        },
        toggleActive(index,) {
            // var old_value = this.isActive[index];
            // this.isActive.fill(false);
            // this.$set(this.isActive, index, old_value);
            this.$set(this.isActive, index, !this.isActive[index]);
        },
        
    }
};
</script>

<style>
.active {
  color: #E65100;
}
</style>
